import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg"  width="100%" height="100%" viewBox="0 0 500.000000 500.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        
<g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1622 3703 l3 -446 95 -58 c52 -32 113 -69 135 -82 22 -13 135 -81
250 -152 116 -70 249 -151 297 -179 48 -28 87 -54 88 -58 0 -3 -55 -40 -122
-82 -179 -109 -485 -294 -625 -378 l-123 -73 0 -513 c0 -283 3 -512 8 -510 18
8 151 87 325 193 104 63 192 115 198 115 5 0 9 3 9 8 0 4 27 23 61 42 70 40
66 38 181 108 48 28 91 52 97 52 5 0 38 -18 72 -39 35 -22 127 -77 204 -124
77 -46 245 -148 374 -225 128 -78 235 -142 237 -142 2 0 27 15 56 33 29 19 60
37 68 40 8 4 44 26 80 48 36 23 101 63 145 89 196 115 521 315 527 324 4 6 8
237 8 514 0 501 0 503 -20 497 -11 -4 -73 -39 -138 -79 -64 -40 -139 -85 -167
-101 -47 -26 -85 -49 -308 -187 -51 -31 -95 -57 -99 -57 -4 -1 -34 -19 -67
-41 -33 -22 -65 -40 -71 -40 -5 0 -10 -6 -10 -12 0 -9 -3 -10 -8 -2 -7 10
-129 94 -137 94 -2 0 -63 36 -134 80 -72 44 -135 80 -140 80 -5 0 -11 4 -13 8
-3 7 -43 33 -127 82 -140 81 -321 194 -321 199 0 3 74 51 166 106 91 55 184
112 207 126 244 151 457 279 462 279 3 0 13 6 21 14 12 12 14 87 14 456 l0
442 -24 -16 c-14 -8 -41 -25 -60 -35 -19 -11 -88 -52 -153 -92 -286 -174 -580
-353 -608 -370 l-31 -18 -82 49 c-46 28 -87 50 -93 50 -5 0 -9 4 -9 9 0 5 -9
12 -20 16 -11 3 -42 22 -69 41 -28 19 -52 34 -55 34 -2 0 -35 19 -72 42 -38
23 -149 90 -246 149 -97 59 -187 114 -200 123 -12 9 -26 16 -30 16 -5 0 -7
-201 -6 -447z m1765 -2395 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z"/>
<path d="M730 2207 l0 -516 113 -69 c61 -38 180 -109 262 -159 83 -50 227
-136 320 -193 94 -57 173 -105 178 -107 4 -2 7 229 7 514 l0 518 -133 79
c-194 116 -445 268 -589 357 -69 44 -133 82 -142 85 -15 6 -16 -42 -16 -509z"/>
<path d="M743 785 c-52 -22 -68 -74 -35 -114 11 -14 42 -28 87 -39 75 -18 95
-42 59 -69 -25 -18 -58 -16 -103 7 -34 17 -41 17 -51 5 -19 -23 -5 -41 44 -60
92 -35 186 5 186 79 0 44 -34 72 -98 82 -83 12 -109 42 -56 66 21 10 35 9 72
-5 41 -14 49 -14 61 -2 20 19 0 41 -48 55 -48 13 -79 12 -118 -5z"/>
<path d="M970 650 l0 -150 30 0 30 0 0 150 0 150 -30 0 -30 0 0 -150z"/>
<path d="M1090 649 l0 -152 78 5 c42 2 90 11 107 19 42 20 75 74 75 123 0 99
-70 156 -192 156 l-68 0 0 -151z m167 76 c31 -20 40 -78 20 -121 -13 -25 -26
-36 -57 -44 -71 -19 -75 -16 -78 79 -4 111 -2 115 51 107 23 -4 52 -13 64 -21z"/>
<path d="M1400 650 l0 -150 110 0 110 0 0 25 c0 25 -1 25 -80 25 l-80 0 0 39
0 40 53 3 c45 3 52 6 55 26 3 21 0 22 -52 22 l-56 0 0 35 0 35 80 0 c79 0 80
0 80 25 l0 25 -110 0 -110 0 0 -150z"/>
<path d="M1670 650 l0 -150 115 0 115 0 0 25 c0 25 -1 25 -85 25 l-85 0 0 40
0 40 55 0 c52 0 55 1 55 25 0 24 -3 25 -55 25 l-55 0 0 35 0 35 80 0 c79 0 80
0 80 25 l0 25 -110 0 -110 0 0 -150z"/>
<path d="M2015 781 c-76 -34 -108 -137 -64 -208 31 -50 70 -66 169 -69 93 -3
107 1 89 22 -8 10 -6 23 10 57 26 54 26 80 1 132 -14 30 -32 48 -64 63 -52 27
-88 27 -141 3z m136 -70 c29 -30 34 -47 23 -88 -5 -18 -11 -22 -30 -17 -38 10
-57 -2 -44 -26 10 -18 8 -20 -24 -20 -42 0 -86 46 -86 90 0 16 11 42 26 59 36
43 93 44 135 2z"/>
<path d="M2280 649 l0 -152 83 5 c97 5 140 25 168 78 24 45 24 84 -2 136 -28
59 -81 84 -177 84 l-72 0 0 -151z m183 61 c17 -19 27 -42 27 -60 0 -18 -11
-41 -27 -60 -23 -25 -37 -31 -73 -33 l-45 -2 -3 84 c-4 111 -2 115 51 107 29
-4 51 -16 70 -36z"/>
<path d="M2674 763 c-22 -52 -104 -256 -104 -260 0 -2 13 -3 30 -3 25 0 31 5
41 40 l12 40 67 0 67 0 12 -40 c10 -35 15 -40 42 -40 36 0 38 -10 -33 173
l-49 127 -35 0 c-29 0 -36 -5 -50 -37z m85 -120 c1 -9 -13 -13 -40 -13 -37 0
-40 2 -33 23 3 12 13 36 22 52 l15 30 18 -40 c10 -22 18 -46 18 -52z"/>
<path d="M2880 775 c0 -23 3 -25 50 -25 l50 0 0 -125 0 -125 30 0 29 0 3 123
3 122 48 3 c42 3 47 5 47 28 l0 24 -130 0 -130 0 0 -25z"/>
<path d="M3263 783 c-4 -14 -66 -165 -110 -270 -3 -9 5 -13 26 -13 27 0 33 5
47 40 l16 40 62 0 63 0 13 -40 c12 -36 17 -40 46 -40 31 0 33 2 24 23 -5 12
-31 78 -58 147 l-50 125 -36 3 c-28 2 -38 -1 -43 -15z m77 -140 c0 -8 -14 -13
-40 -13 l-39 0 14 41 c23 64 27 67 47 24 9 -22 18 -46 18 -52z"/>
<path d="M3537 790 c-46 -14 -57 -29 -57 -76 0 -52 17 -67 102 -84 72 -14 92
-35 59 -61 -30 -24 -57 -24 -106 1 -29 15 -42 17 -52 9 -63 -53 125 -104 194
-53 41 30 45 93 8 122 -15 12 -47 24 -73 28 -57 8 -82 20 -82 39 0 34 62 44
116 19 33 -16 36 -16 49 2 12 17 12 21 -2 32 -38 28 -105 37 -156 22z"/>
<path d="M3750 694 c0 -121 12 -151 67 -178 45 -22 91 -20 131 4 47 29 62 73
62 185 l0 95 -30 0 -30 0 0 -97 c-1 -116 -15 -143 -74 -143 -54 0 -66 25 -66
142 l0 98 -30 0 -30 0 0 -106z"/>
<path d="M4060 650 l0 -150 88 0 c114 0 152 20 152 79 0 23 -7 46 -16 56 -15
14 -15 18 0 49 35 75 -16 116 -144 116 l-80 0 0 -150z m166 86 c33 -25 7 -50
-55 -54 l-51 -3 0 35 c0 36 0 36 43 36 24 0 52 -6 63 -14z m14 -125 c13 -25
13 -27 -6 -45 -10 -10 -33 -16 -65 -16 l-49 0 0 40 0 40 55 0 c43 0 56 -4 65
-19z"/>
</g>

</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
